import { KeyValue } from "@/main/models/common";
import { BodyShopFilterRequest } from "@/main/models/request/bodyshopRequest";
import { IInitialReducerData } from "@/main/services/reducerUtils";

export enum BodyshopTypes {
	GET_BODYSHOPS = "@bodyshop/GET_BODYSHOPS",
	SAVE_BODYSHOPS = "@bodyshop/SAVE_BODYSHOPS",
	RESET_REDUCER_BODYSHOPS = "@bodyshop/RESET_REDUCER_BODYSHOPS",
}

export interface BodyshopState {
	readonly bodyshops: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: IInitialReducerData;
	};
}

export interface GetBodyshops {
	type: typeof BodyshopTypes.GET_BODYSHOPS;
	payload: {
		request: BodyShopFilterRequest;
		keyReducer: string;
	};
}

export interface SaveBodyshops {
	type: typeof BodyshopTypes.SAVE_BODYSHOPS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerBodyshops {
	type: typeof BodyshopTypes.RESET_REDUCER_BODYSHOPS;
}

export type BodyshopActionTypes = GetBodyshops | SaveBodyshops | ResetReducerBodyshops;
